export const USER_MODEL = 'user';

export interface User {
  id: number;
  name: string;
  email: string;
  phone?: string;
  language?: string;
  timezone?: string;
  country?: string;
}
